// Display rule (per boss spec): name always takes priority when present, paired
// with the number (or lid, if no real number). Without a name, lid takes priority
// over number (a lid-only contact's "number" field isn't a real dialable number).
// Every contact has a number, so that's the ultimate fallback.
const getContactDisplayLabel = (contact) => {
  if (!contact) return "";
  // WhatsApp contact updates fall back to `name = number` when there's no
  // real pushname (wbotMessageListener.ts) — that's not a real name, so
  // treat it the same as having no name at all.
  const hasRealName = contact.name && contact.name !== contact.number;
  if (hasRealName) {
    if (contact.number) return `${contact.name} - ${contact.number}`;
    if (contact.lid) return `${contact.name} - ${contact.lid}`;
    return contact.name;
  }
  return contact.lid || contact.number || "";
};

export default getContactDisplayLabel;
